const DELIVERYMAN_APPROVAL_PAGE = {
  pageTitle: 'Gerenciamento',
  sectionTitle: 'Aprovação de Entregadores',
  documentInputLabel: 'Insira o CPF do entregador',
  documentInputPlaceholder: 'Número do CPF',
  confirmationLabel: 'Confirme os dados do Entregador',
  confirmationTitle: 'Confira os dados',
  confirmationButtonLabel: 'OK',
  searchButtonLabel: 'Buscar',
  submitButtonLabel: 'Aprovar',
  approvalFeedback: {
    OPERATIONAL: {
      title: 'Este CPF já foi aprovado!',
      message:
        'O entregador $name já está pronto para começar a fazer entregas. :)',
      buttonRight: 'OK',
    },
    NEW: {
      title: 'Entregador $name aprovado!',
      message: 'Agora ele já está pronto para começar a fazer entregas',
      buttonRight: 'OK',
    },
  },
  approvalFeedbackHexa: {
    title: 'CPF aprovado!',
    closeButton: 'Fechar',
    message: 'O entregador $name já está pronto para começar a fazer entregas.',
  },
  validation: {
    invalid: 'O CPF não é válido',
    required: 'Insira um número de CPF',
    minLength: 'O CPF precisa ter 11 dígitos',
  },
  errors: {
    default: 'Ops, algo deu errado! Tente novamente mais tarde.',
    ligeiro_user_not_found:
      'Este CPF não é de nenhum dos entregadores cadastrados.\nConfirme o número ou peça para o entregador se cadastrar pelo app Zé Entregador.',
    failed_to_get_ligeiro_user:
      'Este CPF não é de nenhum dos entregadores cadastrados.\nConfirme o número ou peça para o entregador se cadastrar pelo app Zé Entregador.',
  },
}

export default DELIVERYMAN_APPROVAL_PAGE
